"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _tableHooks = require("../../../tableHooks");
var _excluded = ["filterOption", "filterType", "setTerm", "setFilterOption", "classes"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var OptionsFilter = function OptionsFilter(_ref) {
  var filterOption = _ref.filterOption,
    filterType = _ref.filterType,
    setTerm = _ref.setTerm,
    setFilterOption = _ref.setFilterOption,
    classes = _ref.classes,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleSelectFilterOption = (0, _react.useCallback)(function (event) {
    var newOption = _tableHooks.FILTER_OPTIONS.find(function (option) {
      return option.type === filterType;
    }).options.find(function (option) {
      return option.id === event.target.value;
    });
    setTerm("");
    setFilterOption(newOption);
  }, [filterType, setTerm, setFilterOption]);
  return /*#__PURE__*/_react.default.createElement(_core.Select, {
    className: classes && classes.selectField,
    variant: "outlined",
    value: filterOption.id,
    onChange: handleSelectFilterOption
  }, _tableHooks.FILTER_OPTIONS.find(function (option) {
    return option.type === filterType;
  }).options.map(function (_ref2) {
    var id = _ref2.id,
      label = _ref2.label;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: id,
      value: id
    }, props && props.intl && props.intl.formatMessage({
      id: label,
      defaultMessage: label
    }));
  }));
};
exports.OptionsFilter = OptionsFilter;